import { Role } from 'constants/roles';

import React from 'react';

import { usePermissions } from 'hooks/usePermissions';
import { useTranslate } from 'react-admin';
import { BooleanInput } from 'shared/react-admin/Inputs';

import { useAutoCreateRefundAndChargeback } from './hooks/useAutoCreateRefundAndChargeback';
import { MerchantShowCommissionsForm } from '../components/MerchantShowCommissionsForm/MerchantShowCommissionsForm';

type Props = {
  errors: string[];
  merchantId: string | undefined;
};

export const MerchantShowCommissionsCreateDialogForm = ({ errors, merchantId }: Props) => {
  const translate = useTranslate();
  const { roles } = usePermissions();
  const isAdmin = roles?.includes(Role.Admin);

  const { isAutoCreateRefundAndChargebackEnabled } = useAutoCreateRefundAndChargeback();

  return (
    <MerchantShowCommissionsForm errors={errors} merchantId={merchantId}>
      {isAdmin && (
        <BooleanInput
          disabled={!isAutoCreateRefundAndChargebackEnabled}
          label={translate('app.merchantCommissions.autoCreateRefundAndChargeback')}
          size="small"
          source="createRelatedPaymentCommissions"
          sx={{ marginBottom: '24px' }}
        />
      )}
    </MerchantShowCommissionsForm>
  );
};
